import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: `100%`,
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(16),
    display: `grid`,
    gridGap: theme.spacing(12, 4),
    gridTemplateColumns: `repeat(2, 1fr)`,
    [theme.breakpoints.down(`sm`)]: {
      gridGap: theme.spacing(8, 4),
      gridTemplateColumns: `repeat(1, 1fr)`,
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(8)
    }
  }
}));

type Props = {
  children: JSX.Element[];
};

const ProductDetailsModuleGrid = ({ children }: Props) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

export default ProductDetailsModuleGrid;
